// Traitement du retour Google OAuth (Emergent Auth)
// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import api, { apiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const hasProcessed = useRef(false);
  const [erreur, setErreur] = useState(null);
  const navigate = useNavigate();
  const { setUser } = useAuth();

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const sessionId = new URLSearchParams(window.location.hash.substring(1)).get("session_id");
    (async () => {
      try {
        // L'échange du session_id se fait UNIQUEMENT côté backend
        const { data } = await api.post("/auth/google/session", { session_id: sessionId });
        setUser(data);
        window.history.replaceState(null, "", "/dashboard");
        navigate("/dashboard", { replace: true });
      } catch (e) {
        const message = apiError(e);
        setErreur(message);
        window.history.replaceState(null, "", "/login");
        setTimeout(() => navigate("/login", { replace: true, state: { message } }), 1500);
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center gap-3 bg-background px-6 text-center">
      <h1 className="font-serif text-3xl font-bold">Inyange</h1>
      {erreur ? (
        <p className="text-sm text-destructive max-w-sm">{erreur}</p>
      ) : (
        <p className="text-sm text-muted-foreground">Connexion en cours…</p>
      )}
    </div>
  );
}
